import type { SchemaType } from '@based/schema'
import { SchemaToType } from './utils'

export const FEATURE_TOGGLE_IDENTIFIERS = {
  overview: 'overview',
  events: 'events',
  developmentArea: 'developmentArea',
  concepts: 'concepts',
  initiatives: 'initiatives',
} as const

export type FeatureToggleIdentifier = keyof typeof FEATURE_TOGGLE_IDENTIFIERS

export const featureToggle = {
  uuid: { type: 'alias', format: 'UUID' },
  identifier: Object.values(FEATURE_TOGGLE_IDENTIFIERS),
  description: { type: 'string' },
  entityType: { type: 'string' },
  enabled: { type: 'boolean' },
  serviceProviders: {
    items: { ref: 'serviceProvider', prop: 'featureToggles' },
  },
  createdAt: { type: 'timestamp', on: 'create' },
  updatedAt: { type: 'timestamp', on: 'update' },
} satisfies SchemaType

export type FeatureToggle = SchemaToType<typeof featureToggle> & {
  id: number
}
